import { createStore } from 'redux';
import RdxReducer  from './rdx-reducer';
import * as rdxState from './rdx-state-mapper';

const configureStore = (state:any = {})=> {
    return createStore(RdxReducer, state);
}
export default configureStore;